(function () {
  function updateFsbHeight() {
    var fsb = document.getElementById('fsb_container');
    var h = fsb ? fsb.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--fsb-height', h + 'px');
  }
  updateFsbHeight();
  window.addEventListener('load', updateFsbHeight);
  window.addEventListener('resize', updateFsbHeight);
  if (window.ResizeObserver) {
    var target = document.getElementById('fsb_container');
    if (target) new ResizeObserver(updateFsbHeight).observe(target);
  }
})();